<template>
  <NuxtLink
    class="fgz-home-link"
    :class="{ '-alumni': layoutConfig.useAuthentication }"
    :to="customLink ?? localePath('/')"
  >
    <span class="screenreader-only">Freies Gymnasium Zürich - zur Startseite</span>
    <img v-if="header?.logo?.url" class="logo -blue" :src="header?.logo?.url" :alt="header.logo.alt as string" />
    <img
      v-if="header?.logoAlternative?.url"
      class="logo -white"
      :src="header.logoAlternative.url"
      :alt="header.logoAlternative.alt as string"
    />
  </NuxtLink>
</template>

<script setup lang="ts">
import type { GetAlumniHeaderQuery, GetHeaderQuery } from '#gql';
import { useLayoutConfig } from '~/app/layout.config';
import { useInternalRoute } from '~/datocms/useInternalRoute';

const localePath = useLocalePath();
const { localeProperties } = useI18n();

const { layoutConfig } = useLayoutConfig();

const { data } = await useFetch<GetHeaderQuery | GetAlumniHeaderQuery>(layoutConfig.headerEndpoint, {
  query: {
    locale: localeProperties.value.siteLocale,
  },
});

const customLink = computed(() => {
  if (data.value?.header && 'home' in data.value.header) {
    return useInternalRoute(data.value.header.home, localeProperties.value.siteLocale).path.value;
  }
  return null;
});

const header = data.value?.header;
</script>

<style scoped lang="scss">
.screenreader-only {
  @include hide-visually;
}

.fgz-home-link {
  margin-right: auto;

  > .logo {
    @media (--xs), (--sm) {
      height: 2.5rem;
    }

    @media (--md) {
      height: 3rem;
    }

    @media (--lg) {
      height: 4.5rem;
    }

    &.-white {
      display: none;
    }
  }

  &.-alumni {
    > .logo {
      @media (--xs), (--sm) {
        height: 3.25rem;
      }
    }
  }
}
</style>
